
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/aiAssistantPanel/assistant/widgets/widgets/FallbackWidget/FallbackWidget.module.scss.css.virtualfile';
        module.exports = {"text":"_text_1r3cf_1"};